/*
|--------------------------------------------------------------------------
| BACK TO TOP: Floating back to top button
|--------------------------------------------------------------------------
*/

__gh__webApp.backToTop = {
	"init":function(){
		var offset = window.innerHeight,
			offsetFade = window.innerHeight * 1.5,
			$backToTop = $('#backToTop'),
			scrollDuration = 500,
			hideTimer;

		$(window).scroll(function() {
			if(hideTimer) {
				clearTimeout(hideTimer);
				hideTimer = 0;
				$backToTop.removeClass('backToTop-hide');
			}

			if($(this).scrollTop() > offset)
				$backToTop.addClass('backToTop-visible');
			else
				$backToTop.removeClass('backToTop-visible backToTop-fade');

			if($(this).scrollTop() > offsetFade)
				$backToTop.addClass('backToTop-fade');
				hideTimer = setTimeout(function() {
					$backToTop.addClass('backToTop-hide');
				}, 2000);
		});

		$backToTop.on('click', function(e) {
			$('body,html').animate({ scrollTop: 0 }, scrollDuration);
			e.preventDefault();
		});
	}

};